/**
 * Zusammengeführter Bereich "Benutzer": vereint die zuvor eigenständigen
 * Menüpunkte "Benutzer", "Rollen & Rechte" und "Nutzerdaten" unter einem
 * einzigen Navigationseintrag mit Reitern oben. Jeder Reiter rendert exakt
 * dieselbe, unveränderte Komponente wie zuvor als eigene Seite (UserList,
 * RoleManagement, NutzerDaten) - keine funktionale Änderung, nur die
 * Navigation wurde konsolidiert.
 *
 * Zugriff: der gesamte Bereich verlangt weiterhin "users.manage" (siehe
 * App.tsx), GENAU wie zuvor für "Benutzer"/"Rollen & Rechte". Der Reiter
 * "Nutzerdaten" bleibt davon unabhängig zusätzlich auf den
 * Systemadministrator beschränkt (siehe NutzerDaten.tsx-Kommentar) - er wird
 * daher hier nur gerendert/angezeigt, wenn user.isSuperAdmin zutrifft, exakt
 * dieselbe Einschränkung wie zuvor über die eigene Route mit
 * requireSuperAdmin. Ein Benutzer mit "users.manage", aber ohne
 * Systemadministrator-Status, sieht diesen Reiter also weiterhin nicht.
 */
import { useState } from "react";
import { useAuth } from "../../context/AuthContext";
import UserList from "./UserList";
import RoleManagement from "../roles/RoleManagement";
import NutzerDaten from "../systemAdmin/NutzerDaten";

type Tab = "users" | "roles" | "nutzerdaten";

export default function UsersHub() {
  const { user } = useAuth();
  const [tab, setTab] = useState<Tab>("users");

  return (
    <div className="space-y-4">
      <div className="flex gap-2 border-b border-surface-border overflow-x-auto">
        <button
          onClick={() => setTab("users")}
          className={`px-3 py-2 text-sm font-medium border-b-2 -mb-px whitespace-nowrap transition-colors ${tab === "users" ? "border-accent text-accent" : "border-transparent text-gray-500 hover:text-gray-300"}`}
        >
          Benutzer
        </button>
        <button
          onClick={() => setTab("roles")}
          className={`px-3 py-2 text-sm font-medium border-b-2 -mb-px whitespace-nowrap transition-colors ${tab === "roles" ? "border-accent text-accent" : "border-transparent text-gray-500 hover:text-gray-300"}`}
        >
          Rollen &amp; Rechte
        </button>
        {user?.isSuperAdmin && (
          <button
            onClick={() => setTab("nutzerdaten")}
            className={`px-3 py-2 text-sm font-medium border-b-2 -mb-px whitespace-nowrap transition-colors ${tab === "nutzerdaten" ? "border-accent text-accent" : "border-transparent text-gray-500 hover:text-gray-300"}`}
          >
            Nutzerdaten
          </button>
        )}
      </div>

      {tab === "users" && <UserList />}
      {tab === "roles" && <RoleManagement />}
      {tab === "nutzerdaten" && user?.isSuperAdmin && <NutzerDaten />}
    </div>
  );
}
